module.exports = __webpack_public_path__ + "static/img/inform@2x.1c80e7eb.png";